import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Grid, Dropdown, Button, Icon} from 'semantic-ui-react';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {parseProviders} from '../../../common/util/options';
import {Actions} from '../../../common/actions';
import GenerateButton from './generateButton';
import SaveButton from './saveButton';

const partTypes = [
  {'text': 'Normales', 'value': '00'},
  {'text': 'INEN', 'value': '01'},
];

class HeadSection extends Component {
  constructor(props) {
    super(props);
    this.state = {'orderDate': moment().subtract(1, 'd')};
    this.timer = null;
  }

  startTimer = () => {
    this.timer = setInterval(() => {
      this.props.checkMadStatus();
    }, 300000);
  };

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  componentDidMount() {
    this.props.checkMadStatus();
    this.startTimer();
    this.props.loadProviders({'withOrigin': true});
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  handleCancelClick = () => {
    const {orderCode} = this.props;
    this.props.cancelProviderStockOrder(orderCode);
  }

  handleRestoreClick = () => {
    this.props.restoreProviderSuggestedOrders();
  }

  handleParameterChange = (event, data) => {
    const {value, name} = data;
    this.props.changeSuggestedOrderParameter(name, value);
  }

  handleSearchClick = () => {
    const {provider, partType} = this.props;

    if (provider && partType) {
      this.props.getProviderSuggestedOrders(provider, partType);
    }
  }

  renderQueryButton = () => {
    const {consulted, loading} = this.props;

    if (consulted || loading) {
      return null;
    }

    return (
      <Button secondary type='button' onClick={this.handleSearchClick}>
        CONSULTAR
      </Button>
    );
  }

  renderRestoreButton = () => {
    const {consulted, loading} = this.props;

    if (!consulted || loading) {
      return null;
    }

    return (
      <Button secondary type='button' onClick={this.handleRestoreClick}>
        RESTABLECER
      </Button>
    );
  }

  renderCancelButton = () => {
    if (this.props.orderCode) {
      return (
        <Button secondary type='button' onClick={this.handleCancelClick}>
          CANCELAR
        </Button>
      );
    }

    return null;
  }

  renderActionButtons = () => {
    const {loading, consulted, verifying} = this.props;

    if (loading) {
      return null;
    }
    if (!consulted) {
      return (
        <Button secondary type='button' onClick={this.handleSearchClick}>
          CONSULTAR
        </Button>
      );
    }

    return (
      <React.Fragment>
        {this.renderCancelButton()}
        <Button primary disabled={verifying} type='submit'>
          GENERAR ARCHIVO
        </Button>
      </React.Fragment>
    );
  }

  renderProviderSelector = () => {
    const {loading, loadingProviders, consulted, provider, providers} =
      this.props;

    return (
      <Dropdown
        fluid
        selection
        loading={loadingProviders}
        disabled={consulted || loadingProviders || loading}
        name='provider'
        value={provider}
        options={parseProviders(providers)}
        onChange={this.handleParameterChange}
      />
    );
  }

  renderPartTypeSelector = () => {
    const {consulted, loading, partType} = this.props;

    return (
      <Dropdown
        fluid
        selection
        disabled={consulted || loading}
        name='partType'
        value={partType}
        options={partTypes}
        onChange={this.handleParameterChange}
      />
    );
  }

  renderMadStatus = () => {
    const {madIsReady, lastJobDate} = this.props.madStatus;
    if (madIsReady) {
      return (
        <>
          <Icon name='check' circular inverted color='green' size='large' />
          <strong>{`Exitoso. Último cálculo: ${moment(lastJobDate).format(
            'DD MMMM YYYY, hh:mm:ss'
          )}`}</strong>
        </>
      );
    }
    return (
      <div id='mad-failed'>
        <Icon name='close' circular inverted color='red' size='large' />
        <strong>{`Falló. Último cálculo: ${moment(lastJobDate).format(
          'DD MMMM YYYY, hh:mm:ss'
        )}`}</strong>
      </div>
    );
  }

  renderOrderCode = () => {
    if (!this.props.orderCode) {
      return null;
    }

    return `(Pedido: ${this.props.orderCode})`;
  }

  render() {
    const {orderDate} = this.state;

    return (
      <Card raised fluid className='head-section'>
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='left'>
              <h2>Pedidos de Stock - Proveedores {this.renderOrderCode()}</h2>
              <div className='order-date'>
                Fecha de corte: {orderDate.format(reverseShortDate)}
              </div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width='4'>
              <label>
                <strong>Proveedor</strong>
              </label>
              {this.renderProviderSelector()}
            </Grid.Column>
            <Grid.Column width='2'>
              <label>
                <strong>Tipo de Artículos</strong>
              </label>
              {this.renderPartTypeSelector()}
            </Grid.Column>
            <Grid.Column width='5'>
              <label>
                <strong> Cálculo del Mad </strong>
              </label>
              {this.renderMadStatus()}
            </Grid.Column>
            <Grid.Column width='5' textAlign='right' verticalAlign='top'>
              {this.renderActionButtons()}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='right' verticalAlign='top'>
              {this.renderRestoreButton()}
              <SaveButton />
              <GenerateButton />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingSuggestions, generating, checkingCode} = state.providerStockOrders;

  return {
    'verifying': state.providerStockOrders.verifying,
    'loadingProviders': state.provider.loading,
    'providers': state.provider.list,
    'loading': loadingSuggestions || checkingCode || generating,
    'consulted': state.providerStockOrders.consulted,
    'provider': state.providerStockOrders.provider,
    'partType': state.providerStockOrders.partType,
    'orderCode': state.providerStockOrders.orderCode,
    'madStatus': state.providerStockOrders.madStatus,
  };
};

const {
  checkMadStatus,
  loadProviders,
  cancelProviderStockOrder,
  getProviderSuggestedOrders,
  changeSuggestedOrderParameter,
  restoreProviderSuggestedOrders,
} = Actions;

export default connect(mapStateToProps, {
  checkMadStatus,
  loadProviders,
  cancelProviderStockOrder,
  getProviderSuggestedOrders,
  changeSuggestedOrderParameter,
  restoreProviderSuggestedOrders,
})(HeadSection);
